module.exports = __webpack_public_path__ + "img/ch16_13_训斥与拥抱.cd8448c9.jpg";